import type { FunctionComponent, SVGProps } from 'react';

export type LanguageSkillProps = SVGProps<SVGSVGElement> & {
    readonly className?: string;
    readonly fill?: string;
    readonly height?: number | string;
    readonly width?: number | string;
};

export const LanguageSkillIcon: FunctionComponent<LanguageSkillProps> = ({
    className = '',
    fill = 'currentColor',
    height = 12,
    width = 12,
    ...props
}) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg
            className={className}
            fill="none"
            height={height}
            viewBox="0 0 12 12"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect fill={fill} height="6" width="12" y="3" />
        </svg>
    );
};
